import RestClient from "@/common/rest_api";

const ApiSuperAdmins = new RestClient(
  "/api/v1/super_admins",
  "super_admins",
  "super_admin"
);

export default ApiSuperAdmins;
